import {
    Select,
    To,
    Lateral,
    Seed,
    Rows,
    Repeatable,
    Unbounded,
    Preceding,
    Following,
    Range,
    Asc,
    Nulls,
    Year,
    Month,
    Day,
    Hour,
    Minute,
    Then,
    Second,
    Any,
    System,
    Current,
    Union,
    Except,
    And,
    Text,
    Block,
    Bernoulli,
    As,
    Between,
    Boolean,
    By,
    Connect_by_root,
    Over,
    X,
    Else,
    Desc,
    Escape,
    First,
    From,
    Full,
    Oj,
    Limit,
    Having,
    Qualify,
    In,
    Is,
    Last,
    Like,
    Local,
    Connect,
    Fetch,
    Next,
    Case,
    Cast,
    Intersect,
    Join,
    Inner,
    Left,
    Outer,
    Right,
    Sample,
    Tablesample,
    Semi,
    Not,
    Null,
    Numeric,
    Offset,
    On,
    Only,
    Or,
    Partition,
    Cross,
    Recursive,
    Distinct,
    Top,
    Natural,
    Order,
    Values,
    Row,
    Group,
    Grouping,
    Sets,
    Cube,
    Obj,
    Rollup,
    Template,
    Timestamp,
    True,
    Try_cast,
    Type,
    Using,
    When,
    Where,
    With,
    End,
    All,
    Into,
    Regexp,
    Ilike,
    Precision,
    Varying,
    Varchar,
    Character,
    Char,
    String,
    Binary,
    Varbinary,
    Decimal,
    Dec,
    Number,
    Timestampltz,
    Timestamp_ltz,
    Zone,
    Timestampntz,
    Timestamp_ntz,
    Without,
    Datetime,
    Timestamptz,
    Timestamp_tz
} from './parser/parser.terms.js';

const keywordTokens = {
    select: Select,
    and: And,
    as: As,
    union: Union,
    intersect: Intersect,
    between: Between,
    blob: Blob,
    values: Values,
    x: X,
    boolean: Boolean,
    by: By,
    group: Group,
    connect: Connect,
    try_cast: Try_cast,
    undbounded: Unbounded,
    Preceding: Preceding,
    following: Following,
    range: Range,
    asc: Asc,
    nulls: Nulls,
    year: Year,
    month: Month,
    hour: Hour,
    second: Second,
    grouping: Grouping,
    sets: Sets,
    cube: Cube,
    obj: Obj,
    rollup: Rollup,
    lateral: Lateral,
    connect_by_root: Connect_by_root,
    case: Case,
    cast: Cast,
    over: Over,
    sample: Sample,
    bernoulii: Bernoulli,
    block: Block,
    tablesample: Tablesample,
    desc: Desc,
    to: To,
    limit: Limit,
    history: History,
    repeatable: Repeatable,
    natural: Natural,
    any: Any,
    oj: Oj,
    then: Then,
    join: Join,
    inner: Inner,
    left: Left,
    outer: Outer,
    right: Right,
    full: Full,
    semi: Semi,
    fetch: Fetch,
    next: Next,
    system: System,
    option: Option,
    current: Current,
    all: All,
    escape: Escape,
    distinct: Distinct,
    set: Set,
    file: File,
    first: First,
    cross: Cross,
    order: Order,
    from: From,
    function: Function,
    except: Except,
    headers: Headers,
    in: In,
    is: Is,
    last: Last,
    like: Like,
    local: Local,
    not: Not,
    numeric: Numeric,
    offset: Offset,
    rows: Rows,
    seed: Seed,
    on: On,
    top: Top,
    only: Only,
    or: Or,
    partition: Partition,
    recursive: Recursive,
    row: Row,
    else: Else,
    having: Having,
    qualify: Qualify,
    storage: Storage,
    template: Template,
    text: Text,
    true: True,
    using: Using,
    when: When,
    where: Where,
    with: With,
    end: End,
    into: Into,
    precsion: Precision,
    varying: Varying,
    varchar: Varchar,
    character: Character,
    char: Char,
    string: String,
    binary: Binary,
    varbinary: Varbinary,
    decimal: Decimal,
    dec: Dec,
    number: Number,
    timestampltz: Timestampltz,
    timestamp_ltz: Timestamp_ltz,
    zone: Zone,
    timestampntz: Timestampntz,
    timestamp_ntz: Timestamp_ntz,
    without: Without,
    datetime: Datetime,
    timestamptz: Timestamptz,
    timestamp_tz: Timestamp_tz
};

export const specializeIdentifier = (value) => keywordTokens[value.toLowerCase()] || -1;

const contextualKeywordTokens = {
    null: Null,
    regexp: Regexp,
    ilike: Ilike,
    type: Type,
    text: Text,
    comment: Comment,
    location: Location,
    minute: Minute,
    day: Day,
    timestamp: Timestamp,
    x: X
};

export const extendIdentifier = (value) => contextualKeywordTokens[value.toLowerCase()] || -1;
